/**
 * @file cmp.ts
 *
 * @fileoverview Custom services for any project should go here.
 *
 * Example :
 *
 * ```
 * export const CUSTOM_SERVICES {
 *  MadeUp: 'Made Up Identifier',
 * }
 * ```
 */

export const CUSTOM_SERVICES = {
  FacebookPixel: 'Facebook Pixel',
}
